import React from 'react';
import './ProductCard.css';

const ProductCard = ({ product, index }) => {
  const handleCardClick = () => {
    window.open(product.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div 
      className="product-card clickable-card"
      style={{ 
        '--primary-color': product.color,
        '--accent-color': product.accentColor,
        '--animation-delay': `${index * 0.2}s`
      }}
      onClick={handleCardClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleCardClick();
        }
      }}
      aria-label={`Open ${product.name} - ${product.description}`}
    >
      <div className="card-header">
        <div className="logo-placeholder">
          <div className="logo-icon">
            <img 
              src={`/${product.name}.svg`} 
              alt={`${product.name} logo`}
              className="logo-image"
            />
          </div>
        </div>
        <div className="product-info">
          <h3 className="product-name">{product.name}</h3>
          <p className="product-description">{product.description}</p>
        </div>
      </div>
      
      <div className="card-body">
        <ul className="features-list">
          {product.features.map((feature, idx) => (
            <li key={idx} className="feature-item">
              <div className="feature-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path 
                    d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span className="feature-text">{feature}</span>
            </li>
          ))}
        </ul>
      </div>
      
      <div className="card-footer">
        <button className="learn-more-btn">
          Visit Platform
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path 
              d="M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
